<div class="title mb-4">
  <h2>Manage Marketplace Blog</h2>
</div>
<ul class="nav nav-tabs">
  <!-- <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: selMenu == 'Blog' }"
      (click)="selectMenu('Blog')"
      >Blog</a
    >
  </li> -->
  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: selMenu == 'Blog&Ads' }"
      (click)="selectMenu('Blog&Ads')"
      >News</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: selMenu == 'Ads' }"
      (click)="selectMenu('Ads')"
      >Admin Ads</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: selMenu == 'banner' }"
      (click)="selectMenu('banner')"
      >Admin Banner</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: selMenu == 'events' }"
      (click)="selectMenu('events')"
      >Events</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: selMenu == 'bulletin' }"
      (click)="selectMenu('bulletin')"
      >Bulletin</a
    >
  </li>
</ul>

<section class="mt-5" *ngIf="selMenu == 'Blog'">
  <div class="form-group">
    <button
      class="btn btn-sm btn-primary"
      (click)="openModalBlogForm(modalBlogForm)"
    >
      <i class="fa-solid fa-plus"></i> Add
    </button>
  </div>
  <div class="table-responsive">
    <table class="table table-hover white_box shadow w-100">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Image</th>
          <th scope="col">Title</th>
          <th scope="col">Author</th>
          <th scope="col">Category</th>
          <th scope="col">Created At</th>
          <th scope="col" class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of blogs?.data; let i = index">
          <th scope="row">{{ i + 1 }}</th>
          <td>
            <img loading="lazy"
              src="{{ baseUrlImgae }}{{ item.image }}"
              height="60px"
              alt=""
            />
          </td>
          <td>{{ item?.title }}</td>
          <td>{{ item?.author }}</td>
          <td>{{ item?.category }}</td>
          <td>{{ convertDate(item?.created) }}</td>
          <td class="text-right">
            <section class="d-flex justify-content-center">
              <button
                class="btn btn-warning rounded-0 rounded-left"
                (click)="editBlog(modalBlogForm, item)"
              >
                <i class="fa-solid fa-edit"></i> Edit
              </button>
              <button
                class="btn btn-danger rounded-0 rounded-right"
                (click)="deleteBlog(item?.id)"
              >
                <i class="fa-solid fa-trash"></i> Delete
              </button>
            </section>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Member Shop -->
</section>
<section class="mt-3" *ngIf="selMenu == 'Blog&Ads'">
  <app-member-news></app-member-news>
</section>
<section class="mt-3" *ngIf="selMenu == 'Ads'">
  <app-member-shop-ads></app-member-shop-ads>
</section>
<section class="mt-3" *ngIf="selMenu == 'banner'">
  <app-member-banner [adminMode]="true"></app-member-banner>
</section>
<section class="mt-3" *ngIf="selMenu == 'events'">
  <app-manage-events></app-manage-events>
</section>
<section class="mt-3" *ngIf="selMenu == 'bulletin'">
  <app-member-bulletin></app-member-bulletin>
</section>

<ng-template #modalBlogForm let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 d-flex">
          <div class="ml-auto">
            <h3>Form Blog</h3>
          </div>
          <div class="ml-auto">
            <i
              (click)="modalService.dismissAll()"
              class="fa fa-window-close pointer"
              aria-hidden="true"
            ></i>
          </div>
        </div>
      </div>
      <div class="edit_cat_modal col-md-12 mx-auto">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="bottomImagesForm">
              <div class="form-group col-md-6 mx-auto prod_upld">
                <input
                  formControlName="banner"
                  type="file"
                  #banner
                  (change)="onBottomBannerSelected(banner.files, $event)"
                  accept="image/*"
                />
                <img loading="lazy"
                  src="../../../assets/images/uploadd1.png"
                  *ngIf="blogImageUrl == ''"
                  class="food_img bottom_banner_img"
                />
                <img loading="lazy"
                  src="{{ blogImageUrl }}"
                  *ngIf="blogImageUrl != ''"
                  class="food_img"
                />
                <ng-container
                  *ngIf="submitted && bottomBannerControl.banner.errors"
                >
                  <p
                    class="error-message"
                    style="padding: 0px; font-size: 12px"
                    *ngIf="bottomBannerControl.banner.errors.required"
                  >
                    Please select image
                  </p>
                </ng-container>
              </div>

              <div class="form-group">
                <label>Title</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="title"
                />
                <ng-container
                  *ngIf="submitted && bottomBannerControl.title.errors"
                >
                  <p
                    class="error-message"
                    style="padding: 0px; font-size: 12px"
                    *ngIf="bottomBannerControl.title.errors.required"
                  >
                    Please enter title
                  </p>
                </ng-container>
              </div>
              <div class="form-group">
                <label>Text</label>
                <app-editor [(innerValue)]="ckEditorText"></app-editor>
                <ng-container *ngIf="submitted">
                  <p
                    class="error-message"
                    style="padding: 0px; font-size: 12px"
                    *ngIf="ckEditorText == ''"
                  >
                    Please enter text
                  </p>
                </ng-container>
              </div>
              <div class="form-group">
                <label>Author</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="author"
                />
                <ng-container
                  *ngIf="submitted && bottomBannerControl.author.errors"
                >
                  <p
                    class="error-message"
                    style="padding: 0px; font-size: 12px"
                    *ngIf="bottomBannerControl.author.errors.required"
                  >
                    Please enter author
                  </p>
                </ng-container>
              </div>
              <div class="form-group">
                <label>Section</label>
                <select formControlName="category" id="" class="form-control">
                  <option value="" selected disabled>Select Section</option>
                  <option *ngFor="let val of categories" [value]="val">
                    {{ val }}
                  </option>
                </select>
                <ng-container
                  *ngIf="submitted && bottomBannerControl.category.errors"
                >
                  <p
                    class="error-message"
                    style="padding: 0px; font-size: 12px"
                    *ngIf="bottomBannerControl.category.errors.required"
                  >
                    Please enter Section
                  </p>
                </ng-container>
              </div>

              <!-- <div class="form-group">
                                <label>URL</label>
                                <input type="text" class="form-control" formControlName="url">
                                <ng-container *ngIf="submitted && bottomBannerControl.url.errors">
                                    <p class="error-message" style="padding: 0px; font-size: 12px"
                                        *ngIf="bottomBannerControl.url.errors.required">
                                        Please enter URL
                                    </p>
                                </ng-container>
                            </div> -->

              <div
                class="d-flex justify-content-center"
                style="padding: 4px; width: 100%"
              >
                <button (click)="addBottomBanner()" class="btn btn-success">
                  <i class="fa-solid fa-save"></i> Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
